import React from 'react';

interface MenuCardProps {
  image: string;
  title: string;
  description: string;
  price: string;
}

const MenuCard: React.FC<MenuCardProps> = ({ image, title, description, price }) => {
  return (
    <div className="bg-primary-black border border-gray-800 rounded-lg overflow-hidden hover:border-primary-gold transition-colors duration-300">
      <div className="w-full h-48 overflow-hidden">
        <img src={image} alt={title} className="w-full h-full object-cover" />
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold text-white mb-3 font-display">{title}</h3>
        <p className="text-gray-400 text-sm mb-4 min-h-[3rem]">{description}</p>
        <p className="text-primary-gold text-2xl font-bold">{price}</p>
      </div>
    </div>
  );
};

export default MenuCard;
